import dateFormat from 'dateformat';
import BaseLandaFinancingSection from 'pages/lend/components/BaseComponents/BaseLandaFinancingSection';
import UtilizationDetails from 'pages/lend/components/LandaFinancingUtilizationRate/components/UtilizationDetails';
import UtilizationGraphLabels from 'pages/lend/components/LandaFinancingUtilizationRate/components/UtilizationGraphLabels';
import UtilizationGraphLegend from 'pages/lend/components/LandaFinancingUtilizationRate/components/UtilizationGraphLegend';
import UtilizationRateGraph from 'pages/lend/components/LandaFinancingUtilizationRate/components/UtilizationRateGraph';
import React from 'react';
import { DebtType } from 'types/debt-types';
import { toPercentageDisplay } from 'utils/number.extensions';
import classes from './index.module.scss';

const LandaFinancingUtilizationRate = ({ debt }: { debt: DebtType }) => {
  const data = debt.utilization;
  const lastUtilization = data[data.length - 1];
  const utilizationRate = lastUtilization.utilizationRatePercentage;
  const currentMonth = dateFormat(
    new Date(lastUtilization.date).toUTC(),
    'mmmm yyyy'
  );

  const loansBalance = lastUtilization.lentAmount;
  const cashBalance = lastUtilization.cashAmount;
  return (
    <BaseLandaFinancingSection
      className={classes.container}
      title={'Utilization Rate'}
      subtitle={toPercentageDisplay(utilizationRate) + '%'}
      subsubtitle={currentMonth}
      titleInfo={`The utilization rate is the percentage of available capital
       invested in mortgages. It's calculated by dividing the total amount of 
       capital invested in mortgages by the raised capital from investors. 
       This rate helps investors understand activity level and risk.`}
      id={'utilization-rate'}
    >
      <UtilizationRateGraph
        className={classes.graph}
        data={data}
      />
      <UtilizationGraphLabels
        className={classes.labels}
        data={data}
      />
      <UtilizationGraphLegend
        className={classes.legend}
        loansBalance={loansBalance}
        cashBalance={cashBalance}
      />
      <UtilizationDetails debt={debt} />
    </BaseLandaFinancingSection>
  );
};

export default LandaFinancingUtilizationRate;
